import { useState } from "react";
import {
  Grid,
  TextField,
  Typography,
  Checkbox,
  FormControlLabel,
  Button,
  Box,
  Paper,
} from "@mui/material";

import routes from "routes";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";
import footerRoutes from "footer.routes";

export default function RegistraEmpleadosPage() {
  const [employees, setEmployees] = useState([
    {
      nombre: "",
      apellido: "",
      dni: "",
      cuit: "",
      direccion: "",
      fechaIngreso: "",
      fechaSalida: "",
    },
  ]);

  const addEmployee = () => {
    setEmployees([
      ...employees,
      {
        nombre: "",
        apellido: "",
        dni: "",
        cuit: "",
        direccion: "",
        fechaIngreso: "",
        fechaSalida: "",
      },
    ]);
  };

  const handleChange = (index, field, value) => {
    const updated = [...employees];
    updated[index][field] = value;
    setEmployees(updated);
  };

  return (
    <>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "external",
          route: "/afiliate",
          label: "Afiliate",
          color: "info",
        }}
        transparent
        light
      />

      <MKBox bgColor="white">
        {/* Top Banner */}
        <MKBox
          minHeight="25rem"
          width="100%"
          sx={{
            backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
              `${linearGradient(
                rgba(gradients.dark.main, 0.8),
                rgba(gradients.dark.state, 0.8)
              )}, url("https://bakersmachinery.com/wp-content/uploads/2024/01/discover-the-famous-master-bakers.jpg")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "grid",
            placeItems: "center",
          }}
        />

        <>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              paddingTop: "2rem",
              paddingBottom: "4rem",
            }}
          >
            <Box sx={{ width: "90%", maxWidth: "1200px" }}>
              <Typography variant="h4" fontWeight="bold" mb={1}>
                Registra tus trabajadores
              </Typography>

              <Box
                sx={{
                  width: "100%",
                  height: "3px",
                  backgroundColor: "#2196f3",
                  mb: 4,
                }}
              />

              <Typography sx={{ mt: 4, mb: 2, color: "black" }}>
                Completá los datos de la empresa y luego agregá los empleados que correspondan. Este
                formulario tiene carácter de declaración jurada.
              </Typography>

              {/* ------------ DATOS DE LA EMPRESA ------------- */}
              <Paper elevation={3} sx={{ p: 4, borderRadius: 3, mt: 2 }}>
                <Typography
                  sx={{
                    mb: 2,
                    fontWeight: 700,
                    color: "black",
                    fontSize: "1.2rem",
                  }}
                >
                  Datos de la Empresa
                </Typography>

                <Grid container spacing={3}>
                  <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Razón Social" />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Nombre de Fantasía" />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Dirección" />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Teléfono" />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="Email" />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TextField fullWidth label="CUIT" />
                  </Grid>
                </Grid>
              </Paper>

              {/* ------------ EMPLEADOS DINÁMICOS ------------- */}
              <Box sx={{ mt: 5 }}>
                {employees.map((emp, index) => (
                  <Paper key={index} elevation={3} sx={{ p: 4, borderRadius: 3, mt: 4 }}>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        color: "black",
                        fontSize: "1.2rem",
                        mb: 2,
                      }}
                    >
                      Empleado {index + 1}
                    </Typography>

                    <Grid container spacing={3}>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Nombre"
                          value={emp.nombre}
                          onChange={(e) => handleChange(index, "nombre", e.target.value)}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="Apellido"
                          value={emp.apellido}
                          onChange={(e) => handleChange(index, "apellido", e.target.value)}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="DNI"
                          value={emp.dni}
                          onChange={(e) => handleChange(index, "dni", e.target.value)}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          label="CUIT"
                          value={emp.cuit}
                          onChange={(e) => handleChange(index, "cuit", e.target.value)}
                        />
                      </Grid>

                      <Grid item xs={12}>
                        <TextField
                          fullWidth
                          label="Dirección"
                          value={emp.direccion}
                          onChange={(e) => handleChange(index, "direccion", e.target.value)}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          type="date"
                          label="Fecha de ingreso"
                          InputLabelProps={{ shrink: true }}
                          value={emp.fechaIngreso}
                          onChange={(e) => handleChange(index, "fechaIngreso", e.target.value)}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <TextField
                          fullWidth
                          type="date"
                          label="Fecha de salida (opcional)"
                          InputLabelProps={{ shrink: true }}
                          value={emp.fechaSalida}
                          onChange={(e) => handleChange(index, "fechaSalida", e.target.value)}
                        />
                      </Grid>
                    </Grid>
                  </Paper>
                ))}

                <Button
                  variant="outlined"
                  sx={{ mt: 3, padding: "0.8rem", fontWeight: 600, background: "blue" }}
                  onClick={addEmployee}
                >
                  + Agregar empleado
                </Button>

                <FormControlLabel
                  sx={{ mt: 4 }}
                  control={<Checkbox />}
                  label="Declaro bajo juramento que la información proporcionada es verdadera."
                />

                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  sx={{ mt: 4, padding: "1rem", fontSize: "1rem", color: "#FFFFFF" }}
                >
                  Enviar formulario
                </Button>
              </Box>
            </Box>
          </Box>
        </>
        <MKBox pt={6} px={1} mt={6}>
          <DefaultFooter content={footerRoutes} />
        </MKBox>
      </MKBox>
    </>
  );
}
